<template>
  <splitpanes class="default-theme">
    <pane min-size="15" size="20">
      <div class="card-header" style="width: 100%;border: solid 1px lightgrey">
        <span style="margin: 5px;font-weight: bold">{{ dirName }}</span>
        <el-icon :size="24" @click="refreshNode(currentDir.id)" style="margin-top: 5px">
          <ElIconRefresh class="el-icon-refresh"/>
        </el-icon>
      </div>

      <el-tree
          ref="tree"
          :data="dirData"
          :props="defaultProps"
          node-key="id"
          :load="loadNode"
          lazy
          @node-click="nodeClickHandle"
          highlight-current
          :expand-on-click-node="false"
          min-height="500px"
          style="height: 100%;overflow: auto"
      >
        <template #default="{ node, data }" v-if="isPdf">
          <el-row style="width:100%" :gutter="1">
            <el-col :span="10" style="line-height: 32px">{{ node.label }}</el-col>

            <el-col :span="2.5" justify="end" v-show="currentDir.id === data.id" style="line-height: 32px;vertical-align: middle">
              <FrameButton v-if="data.leaf" :key="data.id" :button="uploadButton" :parentData="data"></FrameButton>
            </el-col>

          </el-row>
        </template>

      </el-tree>
    </pane>

    <pane min-size="50" style="background-color: white">
      <div class="card-header" style="width: 100%;padding: 3px;border: solid 1px lightgrey;background-color: whitesmoke">
        <el-row style="width: 100%">
          <el-col :span="20">
            <span width="100%" class="department-name">{{ currentDir.full_path }}</span>
          </el-col>
        </el-row>
      </div>
      <div style="background-color: white" v-if="queryId">
        <frame-query ref="frameQuery" :componentParam="queryId" :parent-data="queryParam"></frame-query>
      </div>

      <div style="height: 100%;width: 100%;display: flex;flex-direction: row" v-if="isPdf">
        <PdfView :url="currentUrl" style="width:100%;height: 100%"></PdfView>
      </div>
    </pane>

  </splitpanes>
</template>

<script>

import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import PdfView from "@/views/applications/oa/PdfView.vue";

export default {
  name: "SysDirCommon",
  components: {PdfView, Splitpanes, Pane},
  props: {
    queryId: String,
    dirName : String,
    dirDefId: String,
    isPdf: Boolean,
  },
  computed: {
    queryParam() {
      return {
        dir_id: this.currentDir.id
      }
    }
  },
  data() {
    return {
      uploadButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-UploadFilled",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "help_content_upload","title":"上传PDF","width":800,"height":600}
      },

      dirData: [],
      currentDir: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      loading: false,
      currentUrl:''
    }
  },
  created() {},
  methods: {
    refreshNode(nodeId) {
      if (nodeId && nodeId.length > 0) {
        this.$refs.tree.store.nodesMap[this.currentDir.id].loaded = false;
        this.$refs.tree.store.nodesMap[this.currentDir.id].loadData();
      } else {
        this.loadDirTree()
      }
    },
    //--勾选--
    async nodeClickHandle(currentRow) {
      this.currentDir = currentRow
      if (this.isPdf) {
        let dirId = this.currentDir.id;
        let data = await this.$http('helpCatalogService.getById', {dir_id: dirId})
        if (!data){
          this.currentUrl = '';
          return;
        }
        await this.loadHelpCatalogFile(data.file_id);
      } else {
        this.currentPage = 1
        this.$refs.frameQuery.search();
      }

    },
    async loadDirTree() {
      let data = await this.$http('sysDirService.getChildren', {dir_def_id: this.dirDefId, parent_id: ''})
      this.dirData = data;
    },
    async loadNode(node, resolve) {
      console.log("node.id=" + node.data.id);
      let data = await this.$http('sysDirService.getChildren', {dir_def_id: this.dirDefId, parent_id: node.data.id})
      resolve(data)
    },

    //获取文件目录
    async loadHelpCatalogFile(fileId) {
      if(fileId ===undefined){
        this.currentUrl = '';
        return;
      }
      let params = {fileId:fileId};
      this.currentFile = await this.$http('helpCatalogService.getHelpFile',params);
      if (this.currentFile){
        this.currentUrl = this.currentFile.url;
        return
      }
      this.currentUrl = '';
    },

  },
}
</script>


<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

.dirButtons {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.doc-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  min-height: 600px;
}

.doc-card {
  width: 150px;
  height: 210px;
  margin: 10px;
  border: 1px solid gainsboro;
  border-radius: 10px;
}

.doc-card:hover {
  background-color: #E5F3FF;
}

.file-count {
  color: #409EFF;
  font-size: large;
  margin-left: 5px;
}

.pdf {
  background-image: url("../../../../public/icon/filetype/pdf.png");
}

.excel {
  background-image: url("../../../../public/icon/filetype/excel.png");
}

.word {
  background-image: url("../../../../public/icon/filetype/word.png");
}

.ppt {
  background-image: url("../../../../public/icon/filetype/ppt.png");
}

.png {
  background-image: url("../../../../public/icon/filetype/jpg.png");
}

.file {
  background-image: url("../../../../public/icon/filetype/file.png");
}

.icon {
  width: 100px;
  height: 100px;
  background-size: 100px 100px;
  margin-left: 25px;
}

.doc-name {
  font-size: 16px;
  width: 100%;
  height: 33px;
  margin-top: 10px;
  margin-bottom: 10px;
  //word-wrap: normal;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  line-height: 16px;
  padding-left: 10px;
  text-align: center;
}

.doc-version {
  margin-left: 10px;
  font-size: 20px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-author {
  font-size: 16px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-time {
  font-size: 14px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.doc-status {
  font-size: 12px;
  width: 100%;
}

.doc-menu {
  font-size: 14px;
  margin: 5px 0 0 5px;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.departmentTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.departmentName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}

.mytree {
  margin-left: -15px;

  :deep(.el-tree-node__content) {
    padding: 0 !important;
  }

  :deep(.el-tree-node) {
    position: relative;
    padding-left: 16px;
  }

  :deep(.el-tree-node__children) {
    padding-left: 16px;
  }

  // 竖线
  :deep(.el-tree-node::before) {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #b8b9bb;
  }

  :deep(.el-tree-node:last-child::before) {
    height: 38px;
  }

  // 横线
  :deep(.el-tree-node::after) {
    content: "";
    width: 20px;
    height: 20px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #b8b9bb;
  }

  :deep(& > .el-tree-node::after) {
    border-top: none;
  }

  :deep(& > .el-tree-node::before) {
    border-left: none;
  }

  :deep(.el-tree-node__expand-icon) {
    font-size: 16px;
  }

  :deep(.el-tree-node__expand-icon.is-leaf) {
    visibility: visible !important;
  }

  //:deep(.is-leaf) {
  //  //display: none; // 也可以去掉
  //  position: relative;
  //}

  :deep(.is-leaf)::before {
    content: ''; /* 必须有 content 属性 */
    position: absolute;
    top: 13.5px; /* 将横线定位在元素的中间 */
    left: 0;
    width: 100%;
    border-top: 1px dashed #b8b9bb; /* 虚线 */
    transform: translateY(-50%); /* 微调位置使其完全居中 */
  }
}
</style>
